var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GridBox",style:(_vm.GridStyle)},_vm._l((_vm.gridDatas.data),function(item,index){return _c('div',{key:index,class:_vm.getBoolean(index) ? 'cursorClass' : '',style:({
          ..._vm.BoxStyle,
          ...(_vm.gridDatas.settings && _vm.gridDatas.settings[index])
      }),on:{"click":function($event){return _vm.fn(index)}}},[_vm._t("default",null,{"data":{item, index}}),_vm._v(" "+_vm._s(item)+" ")],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }